/* eslint-disable react/no-danger */
/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import dompurify from 'dompurify';
import { getProduct } from '../../../api';
import { ThemeContext } from '../../../config/theme';
import { Product } from '../../../utils/types';
import themedStyles from './ProductButton.css';

interface Props {
  handle: string;
  isSelected: (product: Product) => boolean;
  basePrice?: number | null;
  setProduct: (product: Product) => void;
  disabled?: boolean;
}

export default function ProductButton(props: Props) {
  const sanitizer = dompurify.sanitize;
  const product = getProduct(props.handle);

  const getPrice = () => {
    const productPrice: number = product.price ? +product.price : 0;
    const basePrice: number = props.basePrice ? +props.basePrice : 0;
    return (productPrice + basePrice) / 100;
  };

  const styling = themedStyles(useContext(ThemeContext));
  const price = getPrice();
  return (
    <button
      css={styling.button}
      onClick={() => props.setProduct(product)}
      disabled={props.disabled}>
      {props.isSelected(product) && <div css={styling.selectedIndicator} />}
      <div
        css={styling.description}
        dangerouslySetInnerHTML={{ __html: sanitizer(product.description) }}
      />
      {props.basePrice ? (
        <h2>{price !== 0 ? price + ' kr' : ''}</h2>
      ) : (
        <h2>{'+' + price + ' kr'}</h2>
      )}
    </button>
  );
}
